import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import { dropRemuneracao } from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const Remuneracao = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const remuneracoes = pessoal?.Remuneracoes ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalRemuneracao',
      id: item?.id,
      pessoal_id: pessoal?.id,
      gradesalario_id: item?.gradesalario_id || null,
      undsalfixo: item?.undsalfixo || null,
      vrsalfx: item?.vrsalfx || '',
      dscsalvar: item?.dscsalvar || '',
      inivalid: item?.inivalid || null,
      fimvalid: item?.fimvalid || null,
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Base da remuneração" disableMargin />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            name="gradesalario_id"
            label="Grade Salarial"
            options={drops?.Gradesalario}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="undsalfixo"
            control={control}
            options={dropRemuneracao}
            label="Unidade do Salário"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="vrsalfx"
            control={control}
            label="Valor do Salário Fixo"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="dscsalvar"
            control={control}
            label="Descrição da Verba"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Período de Validade" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            name="inivalid"
            control={control}
            label="Data de Início"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            name="fimvalid"
            control={control}
            label="Data de Término"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            variant="contained"
            loading={postLoading}
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Remunerações"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Remuneração')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={remuneracoes}
          columns={[
            {
              field: 'gradesalario',
              headerName: 'Grade Salarial',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'undsalfixo',
              headerName: 'Unidade do Salário',
              width: 200,
              sortable: false,
            },
            {
              field: 'vrsalfx',
              headerName: 'Valor do Salário Fixo',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value &&
                value?.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                }),
            },
            {
              field: 'dscsalvar',
              headerName: 'Descrição da Verba',
              width: 200,
              sortable: false,
            },
            {
              field: 'inivalid',
              headerName: 'Data de Início',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'fimvalid',
              headerName: 'Data de Término',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Remuneração')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalRemuneracao', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default Remuneracao;
